import React, { useState, useEffect } from "react";
import "./EnquiryForm.css";

const EnquiryForm = () => {
  const servicesList = [
    "App Development",
    "Game Development",
    "Data Science",
    "Data Analysis",
    "Business Consulting",
    "Cloud Computing",
  ];

  const [selectedServices, setSelectedServices] = useState([]);

  const toggleService = (service) => {
    setSelectedServices((prev) =>
      prev.includes(service)
        ? prev.filter((s) => s !== service)
        : [...prev, service]
    );
  };

  // ⭐ GLOBAL TYPEWRITER EFFECT — All Inputs + Textarea
  useEffect(() => {
    const animatedFields = document.querySelectorAll(".animate-placeholder");

    animatedFields.forEach((field) => {
      const text = field.getAttribute("data-text");
      let index = 0;
      let reverse = false;

      const typeEffect = setInterval(() => {
        if (!reverse) {
          field.placeholder = text.substring(0, index++);
          if (index === text.length + 1) reverse = true;
        } else {
          field.placeholder = text.substring(0, index--);
          if (index < 0) reverse = false;
        }
      }, 120);

      return () => clearInterval(typeEffect);
    });
  }, []);

  return (
    <section className="enquiry-section">
      <div className="enquiry-bg"></div>
      <div className="enquiry-overlay"></div>

      <div className="enquiry-box">
        <h1 className="enquiry-title">Enquiry Form</h1>

        <form action="https://api.web3forms.com/submit" method="POST">
          <input
            type="hidden"
            name="access_key"
            value="157f5dfc-898c-4749-aab8-a80e612db795"
          />

          {/* ⭐ Every Input Has Animated Placeholder Now */}
          <input
            type="text"
            name="name"
            className="animate-placeholder"
            data-text="Your Name *"
            placeholder=""
            required
          />

          <input
            type="email"
            name="email"
            className="animate-placeholder"
            data-text="Email Address *"
            placeholder=""
            required
          />

          <input
            type="text"
            name="mobile"
            className="animate-placeholder"
            data-text="Mobile Number *"
            placeholder=""
            required
          />

          <input
            type="text"
            name="company"
            className="animate-placeholder"
            data-text="Company Name *"
            placeholder=""
            required
          />

          {/* SERVICES GRID */}
          <div className="services-grid">
            {servicesList.map((item, index) => (
              <label
                key={index}
                className={`service-btn ${
                  selectedServices.includes(item) ? "active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  toggleService(item);
                }}
              >
                {item}
                <input
                  type="checkbox"
                  name="services[]"
                  value={item}
                  checked={selectedServices.includes(item)}
                  style={{ display: "none" }}
                  readOnly
                />
              </label>
            ))}
          </div>

          {/* ⭐ Animated Textarea */}
          <textarea
            id="animatedTextarea"
            className="animate-placeholder"
            name="message"
            data-text="Write your message here..."
            placeholder=""
          ></textarea>

          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>
    </section>
  );
};

export default EnquiryForm;
